import React from "react";

const Checked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    role="img"
  >
    <g id="Group_6909" data-name="Group 6909" transform="translate(-10 -13)">
      <path
        id="Path_14463"
        data-name="Path 14463"
        d="M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z"
        transform="translate(10 13)"
        fill="#4b9ce2"
      />
      <path
        id="Path_14457"
        data-name="Path 14457"
        d="M7161.319,452.139h0a1,1,0,0,1-.707-.293l-2.278-2.279a1,1,0,1,1,1.414-1.414l1.571,1.572,5.45-5.45a1,1,0,0,1,1.414,1.414l-6.157,6.157A1,1,0,0,1,7161.319,452.139Z"
        transform="translate(-7142.779 -424.711)"
        fill="#fff"
      />
    </g>
  </svg>
);

export default Checked;
